import client from '../../client';
import { useMutation } from 'react-query';

const createMessage = async (data) => {
  // Expect data: { firstName, lastName, email, subject, body }
  return client.post('/message', data).then(res => res.data);
};

export const useCreateMessageMutation = () => {
  return useMutation({
    mutationFn: createMessage,
  });
};
